exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".m-selector_wrapper{height:28px}select{background-color:#fff;border-radius:4px;border:1px solid #d9d9d9;height:28px;width:110px;color:#112363;margin-left:12px}", ""]);

// exports
